import classNames from 'classnames';
import React, { memo } from 'react';
import Image from '../Image/Image';
import { Highlight, useInstantSearch } from 'react-instantsearch-hooks-web';
import CustomLink from '../CustomLink/CustomLink';
import { rewriteSlug } from '../../utils/RewriteSlug/rewriteSlug.util';
import SbImage from '../SbImage/SbImage';
import { pushToDataLayer } from '../../utils/pushToDataLayer/pushToDataLayer.util';

interface SearchResultsHitProps {
  hit: any;
}

const SearchResultsHit: React.FC<SearchResultsHitProps> = ({ hit }) => {
  const { results } = useInstantSearch();

  const handlepushToDataLayerClickAction = (): void => {
    const { query, nbHits } = results;
    const { heading, full_slug } = hit;
    pushToDataLayer({
      event: 'click_search_results',
      data: {
        search_term: query,
        search_results: nbHits,
        click_search_url: `${process.env.GATSBY_WEBSITE_URL}${full_slug.replace(
          'en-gb/website'
        )}`,
        click_search_text: heading,
      },
    });
  };

  return (
    <CustomLink
      url={rewriteSlug(hit?.full_slug)}
      label={hit.heading}
      className={classNames('block py-12 group', {
        'border-t border-t-border/default': hit?.__position > 1,
      })}
      onClick={handlepushToDataLayerClickAction}
    >
      <div className="flex flex-col items-center justify-center gap-y-8 md:flex-row md:items-start md:justify-start md:gap-y-0 md:gap-x-10">
        <div className="w-full aspect-square bg-border/light md:w-[161px] md:h-[161px] md:max-w-[161px] md:max-h-[161px] md:min-w-[161px] md:min-h-[161px]">
          {hit?.image?.filename && (
            <SbImage
              asset={hit?.image}
              options={{
                width: 161,
                height: 161,
                sizes: { base: 322 },
                objectFit: 'cover',
              }}
            />
          )}
        </div>
        <div className="space-y-5">
          <div className="space-y-3">
            <p className="text-lg text-text/body font-bold group-hover:text-text/body-primary-highlight">
              <Highlight
                attribute="heading"
                classNames={{
                  highlighted: 'bg-button/primary-bg text-system/white',
                }}
                hit={hit}
              />
            </p>
            {hit?.body && (
              <p className="text-base text-text/body">
                <Highlight
                  attribute="body"
                  classNames={{
                    highlighted: 'bg-button/primary-bg text-system/white',
                  }}
                  hit={hit}
                />
              </p>
            )}
          </div>
          {/* <CustomLink
            url={rewriteSlug(hit?.full_slug)}
            className="block text-text/body-primary font-bold"
          >
            Read more →
          </CustomLink> */}
        </div>
      </div>
    </CustomLink>
  );
};

export default memo(SearchResultsHit);
